"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculatorStoreProvider = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const stores_1 = require("../stores/index.js");
const CalculatorStoreProvider = ({ children, calculatorData }) => {
    const storeRef = (0, react_1.useRef)(undefined);
    if (!storeRef.current) {
        storeRef.current = (0, stores_1.createCalculatorStore)(calculatorData);
    }
    return (0, jsx_runtime_1.jsx)(stores_1.CalculatorStoreContext.Provider, { value: storeRef.current, children: children });
};
exports.CalculatorStoreProvider = CalculatorStoreProvider;
